var _g, _g2, _g3, _g4, _g5, _path, _g6, _path2, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 569,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.55 156.577c-4.015 0-7.713 1.034-10.989 2.997-2.325-17.876-17.857-31.721-36.771-31.721-3.17 0-6.129.413-9.087 1.136-2.219-10.332-11.518-18.082-22.718-18.082-5.072 0-9.721 1.55-13.525 4.237-6.023-20.355-25.148-35.234-47.866-35.234-3.487 0-6.869.31-10.144 1.033C203.404 52.735 174.98 33 141.802 33c-44.062 0-79.777 34.924-79.777 78.011 0 6.406.74 12.605 2.219 18.495-6.34-4.133-14.053-6.51-22.295-6.51C18.809 122.996 0 141.388 0 164.017c0 22.628 18.808 41.02 41.949 41.02 3.275 0 6.445-.413 9.404-1.033-.74 1.446-1.162 2.996-1.48 4.649-1.267 8.576 4.861 16.636 13.631 17.876 4.544.62 8.982-.62 12.363-3.307 6.34 14.569 19.97 25.625 37.194 28.105 12.468 1.756 24.62-1.344 34.235-7.956 1.268 17.565 14.899 32.651 33.496 35.234 19.125 2.686 37.088-8.576 42.9-25.935a61.87 61.87 0 0 0 28.952 12.089c33.707 4.753 64.983-18.082 69.95-51.043.105-.516.105-1.033.211-1.55 3.276 4.547 8.348 7.853 14.37 8.68 11.623 1.653 22.507-6.2 24.198-17.669.317-1.963.317-3.823 0-5.683 1.69.413 3.381.62 5.283.62 11.728 0 21.344-9.299 21.344-20.872 0-11.572-9.615-20.665-21.45-20.665Z",
    fill: "#E7F7FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1064.55 128.577c-4.02 0-7.71 1.034-10.99 2.997-2.32-17.876-17.86-31.721-36.77-31.721-3.17 0-6.13.413-9.09 1.136-2.22-10.332-11.515-18.082-22.715-18.082-5.072 0-9.721 1.55-13.525 4.237-6.023-20.355-25.148-35.234-47.866-35.234-3.487 0-6.869.31-10.144 1.033C901.404 24.735 872.98 5 839.802 5c-44.062 0-79.777 34.924-79.777 78.01 0 6.407.74 12.606 2.219 18.496-6.34-4.133-14.053-6.51-22.295-6.51-23.141 0-41.949 18.392-41.949 41.021 0 22.628 18.808 41.02 41.949 41.02 3.275 0 6.445-.413 9.404-1.033-.74 1.446-1.162 2.996-1.479 4.649-1.268 8.576 4.86 16.636 13.63 17.876 4.544.62 8.982-.62 12.363-3.307 6.34 14.569 19.971 25.625 37.194 28.105 12.468 1.756 24.62-1.344 34.235-7.956 1.268 17.565 14.899 32.651 33.496 35.234 19.125 2.686 37.088-8.576 42.9-25.935a61.87 61.87 0 0 0 28.952 12.089c33.707 4.753 64.986-18.082 69.946-51.043.11-.516.11-1.033.22-1.55 3.27 4.547 8.34 7.853 14.37 8.68 11.62 1.653 22.5-6.2 24.19-17.669.32-1.963.32-3.823 0-5.683 1.69.413 3.38.62 5.29.62 11.72 0 21.34-9.299 21.34-20.872 0-11.572-9.62-20.665-21.45-20.665Z",
    fill: "#E7F7FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828.55 156.577c-4.015 0-7.713 1.034-10.989 2.997-2.325-17.876-17.857-31.721-36.771-31.721-3.17 0-6.129.413-9.087 1.136-2.219-10.332-11.518-18.082-22.718-18.082-5.072 0-9.721 1.55-13.525 4.237-6.023-20.355-25.148-35.234-47.866-35.234-3.487 0-6.869.31-10.144 1.033C665.404 52.735 636.98 33 603.802 33c-44.062 0-79.777 34.924-79.777 78.011 0 6.406.74 12.605 2.219 18.495-6.34-4.133-14.053-6.51-22.295-6.51-23.141 0-41.949 18.392-41.949 41.021 0 22.628 18.808 41.02 41.949 41.02 3.275 0 6.445-.413 9.404-1.033-.74 1.446-1.162 2.996-1.479 4.649-1.268 8.576 4.86 16.636 13.63 17.876 4.544.62 8.982-.62 12.363-3.307 6.34 14.569 19.971 25.625 37.194 28.105 12.468 1.756 24.62-1.344 34.235-7.956 1.268 17.565 14.899 32.651 33.496 35.234 19.125 2.686 37.088-8.576 42.9-25.935a61.87 61.87 0 0 0 28.952 12.089c33.707 4.753 64.983-18.082 69.95-51.043.105-.516.105-1.033.211-1.55 3.276 4.547 8.348 7.853 14.37 8.68 11.623 1.653 22.507-6.2 24.198-17.669.317-1.963.317-3.823 0-5.683 1.69.413 3.381.62 5.283.62 11.728 0 21.344-9.299 21.344-20.872 0-11.572-9.615-20.665-21.45-20.665Z",
    fill: "#E7F7FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.55 151.577c-4.015 0-7.713 1.034-10.989 2.997-2.325-17.876-17.857-31.721-36.771-31.721-3.17 0-6.129.413-9.087 1.136-2.219-10.332-11.518-18.082-22.718-18.082-5.072 0-9.721 1.55-13.525 4.237-6.023-20.355-25.148-35.234-47.866-35.234-3.487 0-6.869.31-10.144 1.033C419.404 47.735 390.98 28 357.802 28c-44.062 0-79.777 34.924-79.777 78.011 0 6.406.74 12.605 2.219 18.495-6.34-4.133-14.053-6.51-22.295-6.51-23.141 0-41.949 18.392-41.949 41.021 0 22.628 18.808 41.02 41.949 41.02 3.275 0 6.445-.413 9.404-1.033-.74 1.446-1.162 2.996-1.479 4.649-1.268 8.576 4.86 16.636 13.63 17.876 4.544.62 8.982-.62 12.363-3.307 6.34 14.569 19.971 25.625 37.194 28.105 12.468 1.756 24.62-1.344 34.235-7.956 1.268 17.565 14.899 32.651 33.496 35.234 19.125 2.686 37.088-8.576 42.9-25.935a61.87 61.87 0 0 0 28.952 12.089c33.707 4.753 64.983-18.082 69.95-51.043.105-.516.105-1.033.211-1.55 3.276 4.547 8.348 7.853 14.37 8.68 11.623 1.653 22.507-6.2 24.198-17.669.317-1.963.317-3.823 0-5.683 1.69.413 3.381.62 5.283.62 11.728 0 21.344-9.299 21.344-20.872 0-11.572-9.615-20.665-21.45-20.665Z",
    fill: "#E7F7FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1280.55 123.577c-4.02 0-7.71 1.034-10.99 2.997-2.32-17.876-17.86-31.721-36.77-31.721-3.17 0-6.13.413-9.09 1.136-2.22-10.332-11.51-18.082-22.72-18.082-5.07 0-9.72 1.55-13.52 4.237-6.02-20.355-25.15-35.234-47.87-35.234-3.48 0-6.86.31-10.14 1.033C1117.4 19.735 1088.98 0 1055.8 0c-44.06 0-79.775 34.924-79.775 78.01 0 6.407.74 12.606 2.219 18.496-6.34-4.133-14.053-6.51-22.295-6.51-23.141 0-41.949 18.392-41.949 41.021 0 22.628 18.808 41.02 41.949 41.02 3.275 0 6.445-.413 9.404-1.033-.74 1.446-1.162 2.996-1.479 4.649-1.268 8.576 4.86 16.636 13.63 17.876 4.544.62 8.982-.62 12.363-3.307 6.34 14.569 19.973 25.625 37.193 28.105 12.47 1.756 24.62-1.344 34.24-7.956 1.26 17.565 14.89 32.651 33.49 35.234 19.13 2.686 37.09-8.576 42.9-25.935a61.876 61.876 0 0 0 28.95 12.089c33.71 4.753 64.99-18.082 69.95-51.043.11-.516.11-1.033.22-1.55 3.27 4.547 8.34 7.853 14.37 8.68 11.62 1.653 22.5-6.2 24.19-17.669.32-1.963.32-3.823 0-5.683 1.69.413 3.38.62 5.29.62 11.72 0 21.34-9.299 21.34-20.872 0-11.572-9.62-20.665-21.45-20.665Z",
    fill: "#E7F7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 669,
    y: 281,
    width: 504,
    height: 288
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1173 281H669v288h504V281Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.837,
    d: "M1129.3 536.87c-.12.17-.34.21-.51.09a.359.359 0 0 1-.09-.51c.12-.17 4.07-5.17 4.07-5.17s-3.36 5.43-3.47 5.59Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M702.94 330.16c-.42.59-1.24.74-1.83.32-.59-.42-.74-1.24-.32-1.83.42-.59 14.66-18.62 14.66-18.62s-12.09 19.53-12.51 20.13Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.441,
    d: "M833.23 563.451c-.1.14-.3.18-.44.08a.32.32 0 0 1-.08-.44c.1-.14 3.51-4.46 3.51-4.46s-2.89 4.68-2.99 4.82Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.948,
    d: "M823.15 470.75c-.16.22-.46.28-.68.12a.485.485 0 0 1-.12-.68c.16-.22 5.48-6.96 5.48-6.96s-4.52 7.3-4.68 7.52Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    d: "M1053.56 482.741c-.38.54-1.13.68-1.68.29-.54-.38-.68-1.13-.3-1.68.38-.54 13.42-17.05 13.42-17.05s-11.06 17.9-11.44 18.44Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.707,
    d: "M890.01 417.06c-.16.23-.47.28-.69.12a.488.488 0 0 1-.12-.69c.16-.23 5.55-7.05 5.55-7.05s-4.58 7.39-4.74 7.62Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    d: "M1098.01 501.57c-.14.19-.4.24-.6.11a.442.442 0 0 1-.11-.6c.14-.19 4.8-6.1 4.8-6.1s-3.95 6.39-4.09 6.59Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.535,
    d: "M1129.14 501.071c-.19.27-.55.33-.82.14a.582.582 0 0 1-.14-.82c.19-.27 6.56-8.34 6.56-8.34s-5.41 8.76-5.6 9.02Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.634,
    d: "M874.96 334.78a.64.64 0 0 1-1.05-.73c.2-.29 7.13-9.06 7.13-9.06s-5.87 9.5-6.08 9.79Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.953,
    d: "M773.54 437.781c-.58.82-1.71 1.02-2.53.45a1.825 1.825 0 0 1-.45-2.53c.58-.82 20.24-25.73 20.24-25.73s-16.68 26.99-17.26 27.81Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.645,
    d: "M1038.29 442.701a1.924 1.924 0 0 1-3.15-2.21c.61-.87 21.43-27.23 21.43-27.23s-17.68 28.57-18.28 29.44Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.953,
    d: "M764.03 549.61c-.12.17-.36.22-.54.09a.384.384 0 0 1-.09-.54c.12-.17 4.29-5.45 4.29-5.45s-3.54 5.73-3.66 5.9Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.768,
    d: "M718.94 362.94c-.51.73-1.51.9-2.23.39-.73-.51-.9-1.51-.39-2.23.51-.73 17.88-22.72 17.88-22.72s-14.75 23.83-15.26 24.56Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    d: "M710 389.351c-.42.59-1.23.74-1.82.32-.59-.42-.74-1.23-.32-1.82.42-.59 14.6-18.55 14.6-18.55s-12.05 19.46-12.46 20.05Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.433,
    d: "M1114.87 566.871a.575.575 0 0 1-.94-.66c.18-.26 6.39-8.11 6.39-8.11s-5.27 8.51-5.45 8.77Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "M801.13 502.581a.4.4 0 0 1-.55.1.4.4 0 0 1-.1-.55c.13-.18 4.42-5.62 4.42-5.62s-3.65 5.89-3.77 6.07Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M822.34 417.011a2.451 2.451 0 0 1-3.41.6c-1.11-.77-1.37-2.3-.6-3.41.78-1.11 27.26-34.64 27.26-34.64s-22.48 36.35-23.25 37.45Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "M964.91 564.461a.42.42 0 0 1-.59.1.42.42 0 0 1-.1-.59c.14-.19 4.75-6.04 4.75-6.04s-3.93 6.34-4.06 6.53Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M735.15 299.6c-.17.25-.52.31-.77.13a.547.547 0 0 1-.13-.77c.17-.25 6.14-7.8 6.14-7.8s-5.06 8.19-5.24 8.44Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    d: "M837.28 443.501a.42.42 0 0 1-.59.1.42.42 0 0 1-.1-.59c.14-.19 4.75-6.04 4.75-6.04s-3.92 6.34-4.06 6.53Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.756,
    d: "M1135.02 403.01c-.1.15-.3.18-.45.08-.15-.1-.18-.3-.08-.45.1-.15 3.59-4.56 3.59-4.56s-2.96 4.78-3.06 4.93Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M853.73 482.431c-.32.46-.95.57-1.41.25-.46-.32-.57-.95-.25-1.41.32-.46 11.29-14.34 11.29-14.34s-9.31 15.04-9.63 15.5Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M962.29 313.241a.337.337 0 0 1-.55-.39c.11-.15 3.77-4.79 3.77-4.79s-3.12 5.03-3.22 5.18Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.737,
    d: "M1002.92 467.331c-.17.24-.51.3-.75.13a.542.542 0 0 1-.13-.75c.17-.24 6-7.62 6-7.62s-4.94 7.99-5.12 8.24Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M1121.83 298.871c-.27.39-.8.48-1.19.21a.851.851 0 0 1-.21-1.19c.27-.39 9.52-12.09 9.52-12.09s-7.85 12.68-8.12 13.07Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M730 490.361c-.58.82-1.71 1.02-2.53.44a1.814 1.814 0 0 1-.44-2.53c.58-.82 20.23-25.71 20.23-25.71s-16.68 26.98-17.26 27.8Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.602,
    d: "M668.1 469.14c-.1.14-.29.17-.42.07a.294.294 0 0 1-.07-.42c.1-.14 3.38-4.29 3.38-4.29s-2.8 4.5-2.89 4.64Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    d: "M1010.81 508.85c-.54.77-1.61.96-2.38.42-.77-.54-.96-1.61-.42-2.38.54-.77 19.06-24.23 19.06-24.23s-15.72 25.41-16.26 26.19Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.424,
    d: "M676.43 568.331c-.1.15-.31.19-.46.08a.324.324 0 0 1-.08-.46c.11-.15 3.69-4.69 3.69-4.69s-3.04 4.92-3.15 5.07Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.532,
    d: "M1122.38 456.61a.85.85 0 0 1-1.18.21.85.85 0 0 1-.21-1.18c.27-.38 9.43-11.98 9.43-11.98s-7.77 12.57-8.04 12.95Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.822,
    d: "M1153.54 446.23c-.43.62-1.28.76-1.9.33-.62-.43-.76-1.28-.33-1.9.43-.62 15.17-19.28 15.17-19.28s-12.51 20.23-12.94 20.85Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.521,
    d: "M938.1 293.921c-.22.32-.66.39-.97.17a.693.693 0 0 1-.17-.97c.22-.32 7.79-9.9 7.79-9.9s-6.43 10.39-6.65 10.7Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.446,
    d: "M829.86 346.21a.73.73 0 0 1-1.03.18.73.73 0 0 1-.18-1.03c.23-.34 8.26-10.5 8.26-10.5s-6.82 11.02-7.05 11.35Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.955,
    d: "M807.47 433.29c-.14.2-.42.25-.63.11a.458.458 0 0 1-.11-.63c.14-.2 5.01-6.37 5.01-6.37s-4.12 6.68-4.27 6.89Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.678,
    d: "M1008.02 433.901a1.623 1.623 0 0 1-2.66-1.86c.52-.74 18.12-23.03 18.12-23.03s-14.95 24.15-15.46 24.89Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M828.3 510.19c-.55.78-1.62.97-2.4.42a1.72 1.72 0 0 1-.42-2.4c.55-.78 19.18-24.38 19.18-24.38s-15.81 25.59-16.36 26.36Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.846,
    d: "M976.99 483.85a.37.37 0 0 1-.52.09.37.37 0 0 1-.09-.52c.12-.17 4.15-5.27 4.15-5.27s-3.42 5.53-3.54 5.7Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M970.99 524.19c-.23.33-.69.41-1.03.18a.737.737 0 0 1-.18-1.03c.23-.34 8.21-10.43 8.21-10.43s-6.77 10.94-7 11.28Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.949,
    d: "M715.51 513.37a.7.7 0 0 1-.97.17.7.7 0 0 1-.17-.97c.22-.31 7.74-9.84 7.74-9.84s-6.38 10.33-6.6 10.64Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.696,
    d: "M666.18 337.13a.465.465 0 1 1-.76-.54c.15-.21 5.18-6.59 5.18-6.59s-4.27 6.92-4.42 7.13Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.897,
    d: "M745.71 522.651a.51.51 0 0 1-.71.12.51.51 0 0 1-.12-.71c.16-.23 5.64-7.17 5.64-7.17s-4.65 7.53-4.81 7.76Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    d: "M1043.99 404.96a1.156 1.156 0 1 1-1.89-1.33c.37-.52 12.92-16.42 12.92-16.42s-10.66 17.22-11.03 17.75Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.799,
    d: "M1021.86 372.981c-.31.44-.91.54-1.35.24a.975.975 0 0 1-.24-1.35c.31-.44 10.78-13.69 10.78-13.69s-8.88 14.36-9.19 14.8Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.579,
    d: "M749.74 451.45c-.33.47-.98.59-1.45.26-.47-.33-.59-.98-.26-1.45.33-.47 11.62-14.76 11.62-14.76s-9.58 15.48-9.91 15.95Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.555,
    d: "M808.83 321.171a1.8 1.8 0 0 1-2.52.44 1.8 1.8 0 0 1-.44-2.52c.57-.82 20.19-25.66 20.19-25.66s-16.65 26.92-17.23 27.74Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.901,
    d: "M754.68 384.88a1.87 1.87 0 0 1-2.59.46 1.87 1.87 0 0 1-.46-2.59c.59-.84 20.72-26.33 20.72-26.33s-17.08 27.62-17.67 28.46Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M776.76 337.191c-.39.55-1.14.68-1.69.3-.55-.39-.68-1.14-.3-1.69.39-.55 13.55-17.21 13.55-17.21s-11.18 18.05-11.56 18.6Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.511,
    d: "M1104.32 345.91c-.12.17-.36.21-.53.09a.383.383 0 0 1-.09-.53c.12-.17 4.25-5.4 4.25-5.4s-3.51 5.67-3.63 5.84Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.841,
    d: "M1048.59 330.3a.288.288 0 0 1-.47-.33c.09-.13 3.2-4.06 3.2-4.06s-2.64 4.26-2.73 4.39Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M724.79 422.89a.288.288 0 0 1-.47-.33c.09-.13 3.21-4.08 3.21-4.08s-2.65 4.28-2.74 4.41Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.617,
    d: "M1152.96 572.24a2.216 2.216 0 0 1-3.1.54 2.216 2.216 0 0 1-.54-3.1c.7-1.01 24.78-31.49 24.78-31.49s-20.44 33.04-21.14 34.05Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.896,
    d: "M1071.54 443.361c-.13.19-.4.24-.59.1a.419.419 0 0 1-.1-.59c.13-.19 4.74-6.02 4.74-6.02s-3.92 6.32-4.05 6.51Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.422,
    d: "M908.19 450.53a2.212 2.212 0 0 1-3.62-2.54c.7-1 24.67-31.34 24.67-31.34s-20.35 32.87-21.05 33.88Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.461,
    d: "M669.6 380.6a1.028 1.028 0 0 1-1.68-1.18c.33-.47 11.46-14.56 11.46-14.56s-9.46 15.28-9.78 15.74Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.743,
    d: "M785.16 479.07c-.61.87-1.81 1.08-2.67.47a1.914 1.914 0 0 1-.47-2.67c.61-.87 21.4-27.2 21.4-27.2s-17.65 28.53-18.26 29.4Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M867.93 463.99c-.58.82-1.71 1.02-2.53.44a1.814 1.814 0 0 1-.44-2.53c.58-.82 20.23-25.71 20.23-25.71s-16.69 26.98-17.26 27.8Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.858,
    d: "M869.99 285.26c-.1.14-.3.18-.44.08a.32.32 0 0 1-.08-.44c.1-.14 3.54-4.49 3.54-4.49s-2.92 4.7-3.02 4.85Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.818,
    d: "M855.05 405.67a1.989 1.989 0 1 1-3.26-2.28c.63-.9 22.16-28.16 22.16-28.16s-18.27 29.55-18.9 30.44Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.632,
    d: "M1059.21 292.331c-.12.17-.36.22-.53.09a.374.374 0 0 1-.09-.53c.12-.17 4.27-5.42 4.27-5.42s-3.53 5.68-3.65 5.86Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1031.21 459.881c-.14.2-.42.25-.62.11a.448.448 0 0 1-.11-.62c.14-.2 4.93-6.27 4.93-6.27s-4.06 6.58-4.2 6.78Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.544,
    d: "M920.99 400.78c-.23.33-.68.41-1.01.18a.723.723 0 0 1-.18-1.01c.23-.33 8.12-10.32 8.12-10.32s-6.7 10.82-6.93 11.15Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.605,
    d: "M1120.39 338.4a2.423 2.423 0 0 1-3.38.59 2.423 2.423 0 0 1-.59-3.38c.77-1.1 27.04-34.36 27.04-34.36s-22.3 36.05-23.07 37.15Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.575,
    d: "M696.39 408.95a.29.29 0 0 1-.41.07.29.29 0 0 1-.07-.41c.09-.13 3.3-4.19 3.3-4.19s-2.73 4.4-2.82 4.53Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.883,
    d: "M899.11 532.45c-.65.93-1.93 1.15-2.85.5a2.042 2.042 0 0 1-.5-2.85c.65-.93 22.84-29.03 22.84-29.03s-18.84 30.46-19.49 31.38Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.461,
    d: "M860.57 425.88a.61.61 0 1 1-1-.7c.19-.27 6.83-8.68 6.83-8.68s-5.63 9.1-5.83 9.38Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    d: "M935.47 339.08c-.31.44-.91.55-1.35.24a.966.966 0 0 1-.24-1.35c.31-.44 10.84-13.78 10.84-13.78s-8.94 14.45-9.25 14.89Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.488,
    d: "M686.25 522.15c-.15.21-.43.26-.64.11a.454.454 0 0 1-.11-.64c.15-.21 5.15-6.54 5.15-6.54s-4.25 6.86-4.4 7.07ZM854.39 362.301a.4.4 0 0 1-.55.1.398.398 0 0 1-.1-.55c.13-.18 4.43-5.63 4.43-5.63s-3.66 5.9-3.78 6.08Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.971,
    d: "M1068.42 364.05c-.21.3-.63.38-.94.16a.672.672 0 0 1-.16-.94c.21-.3 7.5-9.53 7.5-9.53s-6.19 10.01-6.4 10.31Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.907,
    d: "M1024.99 297.53c-.3.42-.88.52-1.3.23a.942.942 0 0 1-.23-1.3c.3-.42 10.4-13.21 10.4-13.21s-8.58 13.86-8.87 14.28Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.853,
    d: "M1007.65 348.58c-.7.99-2.07 1.23-3.06.54-.99-.7-1.23-2.07-.54-3.06.7-.99 24.48-31.11 24.48-31.11s-20.18 32.63-20.88 33.63Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.848,
    d: "M1086.29 483.971c-.58.83-1.72 1.03-2.54.45a1.819 1.819 0 0 1-.45-2.54c.58-.83 20.35-25.86 20.35-25.86s-16.78 27.12-17.36 27.95Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.707,
    d: "M667.77 547.05c-.14.2-.41.24-.6.11a.434.434 0 0 1-.11-.6c.14-.2 4.81-6.11 4.81-6.11s-3.97 6.41-4.1 6.6Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "M1097.01 443.28a1.861 1.861 0 0 1-3.05-2.13c.59-.84 20.74-26.36 20.74-26.36s-17.1 27.65-17.69 28.49Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M668.58 405.191c-.12.17-.36.21-.53.09a.383.383 0 0 1-.09-.53c.12-.17 4.26-5.41 4.26-5.41s-3.52 5.68-3.64 5.85Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.884,
    d: "M886.48 564.601c-.32.46-.95.57-1.41.25-.46-.32-.57-.95-.25-1.41.32-.46 11.28-14.34 11.28-14.34s-9.29 15.04-9.62 15.5Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.406,
    d: "M830.24 287.861c-.09.13-.27.16-.39.07a.277.277 0 0 1-.07-.39c.09-.13 3.16-4.02 3.16-4.02s-2.61 4.21-2.7 4.34Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.805,
    d: "M1086.96 402.03c-.11.15-.32.19-.48.08a.348.348 0 0 1-.08-.48c.11-.15 3.81-4.84 3.81-4.84s-3.14 5.09-3.25 5.24Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M860.9 548.18a.29.29 0 0 1-.41.07.29.29 0 0 1-.07-.41c.09-.13 3.29-4.18 3.29-4.18s-2.72 4.39-2.81 4.52Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M1033.96 561.28c-.63.9-1.87 1.12-2.76.49-.9-.63-1.12-1.87-.49-2.76.63-.9 22.12-28.11 22.12-28.11s-18.24 29.48-18.87 30.38Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.496,
    d: "M999.6 310.27c-.17.24-.51.3-.75.13a.542.542 0 0 1-.13-.75c.17-.24 6.03-7.67 6.03-7.67s-4.98 8.05-5.15 8.29Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M1052.04 525.24c-.62.89-1.84 1.1-2.73.48-.89-.62-1.1-1.84-.48-2.73.62-.89 21.83-27.74 21.83-27.74s-18 29.1-18.62 29.99Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.459,
    d: "M960.01 395.461a.337.337 0 0 1-.55-.39c.11-.15 3.78-4.8 3.78-4.8s-3.13 5.04-3.23 5.19Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.964,
    d: "M1093.2 539.751a1.349 1.349 0 1 1-2.21-1.55c.43-.61 15.07-19.15 15.07-19.15s-12.43 20.09-12.86 20.7Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.713,
    d: "M973.4 437.97a.53.53 0 1 1-.87-.61c.17-.24 5.94-7.54 5.94-7.54s-4.9 7.91-5.07 8.15Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.638,
    d: "M888.27 384.6c-.33.47-.98.59-1.46.26-.47-.33-.59-.98-.26-1.46.33-.47 11.67-14.83 11.67-14.83s-9.62 15.55-9.95 16.03Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.745,
    d: "M1017.31 568.12c-.09.12-.26.15-.38.07a.284.284 0 0 1-.07-.38c.09-.12 3.04-3.86 3.04-3.86s-2.51 4.05-2.59 4.17Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.435,
    d: "M687.23 492.11c-.66.95-1.97 1.18-2.92.51a2.088 2.088 0 0 1-.51-2.92c.66-.95 23.34-29.66 23.34-29.66s-19.24 31.13-19.91 32.07Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    d: "M752.08 408.8c-.32.46-.96.58-1.43.25-.46-.32-.58-.96-.25-1.43.32-.46 11.42-14.51 11.42-14.51s-9.41 15.22-9.74 15.69Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.773,
    d: "M971.34 380.731c-.6.86-1.78 1.07-2.64.46-.86-.6-1.07-1.78-.46-2.64.6-.86 21.15-26.87 21.15-26.87s-17.45 28.19-18.05 29.05Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.801,
    d: "M1133.1 370.871c-.69.98-2.05 1.22-3.03.53a2.17 2.17 0 0 1-.53-3.03c.69-.98 24.27-30.85 24.27-30.85s-20.02 32.37-20.71 33.35Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.774,
    d: "M799.94 355.271a.288.288 0 0 1-.47-.33c.09-.13 3.22-4.09 3.22-4.09s-2.65 4.29-2.75 4.42Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.534,
    d: "M909.2 324.37a1.056 1.056 0 0 1-1.73-1.21c.33-.48 11.78-14.96 11.78-14.96s-9.72 15.7-10.05 16.17Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.628,
    d: "M760.82 505.61a1.974 1.974 0 1 1-3.23-2.27c.63-.89 21.99-27.94 21.99-27.94s-18.13 29.32-18.76 30.21Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.658,
    d: "M744.6 567.27a.353.353 0 0 1-.58-.4c.11-.16 3.93-5 3.93-5s-3.24 5.24-3.35 5.4Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M1156.61 334.721a2.337 2.337 0 0 1-3.25.57 2.328 2.328 0 0 1-.57-3.25c.74-1.05 25.98-33.02 25.98-33.02s-21.42 34.64-22.16 35.7Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.454,
    d: "M705.68 563.08c-.5.71-1.48.89-2.2.39-.71-.5-.89-1.48-.39-2.2.5-.71 17.6-22.36 17.6-22.36s-14.51 23.45-15.01 24.17Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.553,
    d: "M1162.57 290.45c-.13.19-.4.24-.59.1a.419.419 0 0 1-.1-.59c.13-.19 4.7-5.97 4.7-5.97s-3.87 6.27-4.01 6.46Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.768,
    d: "M870.62 506.89a.29.29 0 0 1-.41.07.29.29 0 0 1-.07-.41c.09-.13 3.32-4.22 3.32-4.22s-2.75 4.42-2.84 4.56Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.682,
    d: "M979.18 343.75a.818.818 0 1 1-1.34-.94c.26-.37 9.11-11.58 9.11-11.58s-7.51 12.15-7.77 12.52Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.844,
    d: "M1094.71 286.811c-.09.13-.26.16-.39.07a.276.276 0 0 1-.07-.39c.09-.13 3.1-3.94 3.1-3.94s-2.55 4.14-2.64 4.26Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.506,
    d: "M860.99 307.87c-.1.15-.3.18-.45.08-.15-.1-.18-.3-.08-.45.1-.15 3.58-4.55 3.58-4.55s-2.95 4.77-3.05 4.92Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.771,
    d: "M895.87 491.331a2.437 2.437 0 0 1-3.39.6 2.437 2.437 0 0 1-.6-3.39c.77-1.1 27.11-34.45 27.11-34.45s-22.35 36.14-23.12 37.24Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    d: "M990.13 409.14c-.46.66-1.37.82-2.02.36-.65-.46-.82-1.37-.36-2.02.46-.66 16.19-20.57 16.19-20.57s-13.35 21.57-13.81 22.23Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M987.17 556.64c-.43.62-1.28.77-1.9.33-.62-.43-.77-1.28-.33-1.9.43-.62 15.21-19.33 15.21-19.33s-12.54 20.28-12.98 20.9Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.475,
    d: "M798.76 566.261c-.1.14-.29.17-.43.08-.14-.09-.17-.29-.08-.43.1-.14 3.46-4.39 3.46-4.39s-2.85 4.6-2.95 4.74Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.859,
    d: "M1167.63 401.29a.69.69 0 0 1-1.13-.79c.22-.31 7.65-9.72 7.65-9.72s-6.3 10.2-6.52 10.51Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    d: "M792.11 544.431c-.48.68-1.41.84-2.09.37-.68-.48-.84-1.41-.37-2.09.48-.68 16.74-21.28 16.74-21.28s-13.8 22.33-14.28 23Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M1172.17 497.3c-.17.25-.51.31-.76.13a.535.535 0 0 1-.13-.76c.17-.25 6.08-7.73 6.08-7.73s-5.01 8.12-5.19 8.36Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.661,
    d: "M797.07 394.19a1.17 1.17 0 0 1-1.92-1.34c.37-.53 13.08-16.62 13.08-16.62s-10.79 17.43-11.16 17.96Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.767,
    d: "M925.75 564.291a.402.402 0 0 1-.66-.46c.13-.18 4.51-5.74 4.51-5.74s-3.73 6.01-3.85 6.2Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    d: "M941.38 477.03a2.162 2.162 0 0 1-3.54-2.48c.68-.98 24.09-30.61 24.09-30.61s-19.86 32.11-20.55 33.09Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.803,
    d: "M901.16 354.6a.56.56 0 0 1-.77.14.558.558 0 0 1-.14-.77c.18-.25 6.17-7.84 6.17-7.84s-5.08 8.22-5.26 8.47Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.478,
    d: "M1011.03 533.81a1.156 1.156 0 1 1-1.89-1.33c.37-.52 12.88-16.36 12.88-16.36s-10.62 17.17-10.99 17.69Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M985.11 287.16c-.11.16-.34.2-.5.09a.365.365 0 0 1-.09-.5c.11-.16 4.04-5.13 4.04-5.13s-3.33 5.38-3.45 5.54Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.568,
    d: "M936.85 438.36a2.4 2.4 0 0 1-3.33.59 2.4 2.4 0 0 1-.59-3.33c.75-1.08 26.67-33.89 26.67-33.89s-22 35.55-22.75 36.63Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M1078.68 325.67c-.52.75-1.56.93-2.31.41s-.93-1.56-.41-2.31 18.45-23.44 18.45-23.44-15.21 24.59-15.73 25.34Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.519,
    d: "M746.79 339.561c-.21.3-.63.38-.93.16a.661.661 0 0 1-.16-.93c.21-.3 7.47-9.49 7.47-9.49s-6.17 9.96-6.38 10.26Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.828,
    d: "M703.36 466.331a2.248 2.248 0 0 1-3.14.55 2.248 2.248 0 0 1-.55-3.14c.71-1.02 25.13-31.93 25.13-31.93s-20.73 33.5-21.44 34.52Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M677.63 308.27c-.62.88-1.84 1.1-2.72.48-.88-.62-1.1-1.84-.48-2.72.62-.88 21.78-27.67 21.78-27.67s-17.96 29.03-18.58 29.91Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M686.65 357.721c-.42.6-1.24.74-1.83.32-.6-.42-.74-1.24-.32-1.83.42-.6 14.68-18.65 14.68-18.65s-12.11 19.56-12.53 20.16Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.864,
    d: "M773.86 299.861c-.3.43-.9.54-1.33.23a.95.95 0 0 1-.23-1.33c.3-.43 10.66-13.54 10.66-13.54s-8.8 14.21-9.1 14.64Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.954,
    d: "M828.79 535.91c-.31.44-.92.55-1.36.24a.978.978 0 0 1-.24-1.36c.31-.44 10.92-13.88 10.92-13.88s-9.01 14.56-9.32 15Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.503,
    d: "M1168.11 359.57c-.2.28-.58.35-.86.15a.613.613 0 0 1-.15-.86c.2-.28 6.87-8.73 6.87-8.73s-5.67 9.16-5.86 9.44Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.895,
    d: "M1140.34 490.56a2.24 2.24 0 0 1-3.11.55 2.24 2.24 0 0 1-.55-3.11c.71-1.01 24.85-31.58 24.85-31.58s-20.48 33.13-21.19 34.14Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.499,
    d: "M1161.28 520.84a.288.288 0 0 1-.47-.33c.09-.13 3.23-4.1 3.23-4.1s-2.67 4.3-2.76 4.43Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.465,
    d: "M938.47 529.791c-.14.2-.41.25-.61.11a.436.436 0 0 1-.11-.61c.14-.2 4.91-6.23 4.91-6.23s-4.05 6.53-4.19 6.73Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M1099.84 390.34c-.69.98-2.04 1.22-3.01.53a2.156 2.156 0 0 1-.53-3.01c.69-.98 24.12-30.65 24.12-30.65s-19.9 32.15-20.58 33.13Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M1075.16 559.93c-.12.17-.36.21-.53.09a.383.383 0 0 1-.09-.53c.12-.17 4.23-5.38 4.23-5.38s-3.49 5.65-3.61 5.82Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.428,
    d: "M665.4 506.05c-.16.22-.47.28-.69.12a.497.497 0 0 1-.12-.69c.16-.22 5.54-7.04 5.54-7.04s-4.58 7.38-4.73 7.61Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.624,
    d: "M934.84 493.49c-.09.12-.26.15-.38.07a.284.284 0 0 1-.07-.38c.09-.12 3.04-3.86 3.04-3.86s-2.5 4.04-2.59 4.17Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.892,
    d: "M670.76 440.22c-.25.35-.74.44-1.09.19a.785.785 0 0 1-.19-1.09c.25-.35 8.71-11.07 8.71-11.07s-7.18 11.61-7.43 11.97Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M899.15 294.58c-.18.26-.54.33-.81.14a.577.577 0 0 1-.14-.81c.18-.26 6.45-8.2 6.45-8.2s-5.32 8.61-5.5 8.87Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.467,
    d: "M935.34 370.44a1.04 1.04 0 0 1-1.7-1.2c.33-.47 11.58-14.71 11.58-14.71s-9.55 15.44-9.88 15.91Z",
    fill: "#B5E3FF"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 279,
    width: 504,
    height: 288
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M633 279H129v288h504V279Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.837,
    d: "M589.3 534.87c-.12.17-.34.21-.51.09a.359.359 0 0 1-.09-.51c.12-.17 4.07-5.17 4.07-5.17s-3.36 5.43-3.47 5.59Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M162.94 328.16c-.42.59-1.24.74-1.83.32-.59-.42-.74-1.24-.32-1.83.42-.59 14.66-18.62 14.66-18.62s-12.09 19.53-12.51 20.13Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.441,
    d: "M293.23 561.451c-.1.14-.3.18-.44.08a.32.32 0 0 1-.08-.44c.1-.14 3.51-4.46 3.51-4.46s-2.89 4.68-2.99 4.82Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.948,
    d: "M283.15 468.75c-.16.22-.46.28-.68.12a.485.485 0 0 1-.12-.68c.16-.22 5.48-6.96 5.48-6.96s-4.52 7.3-4.68 7.52Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    d: "M513.56 480.741c-.38.54-1.13.68-1.68.29-.54-.38-.68-1.13-.3-1.68.38-.54 13.42-17.05 13.42-17.05s-11.06 17.9-11.44 18.44Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.707,
    d: "M350.01 415.06c-.16.23-.47.28-.69.12a.488.488 0 0 1-.12-.69c.16-.23 5.55-7.05 5.55-7.05s-4.58 7.39-4.74 7.62Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    d: "M558.01 499.57c-.14.19-.4.24-.6.11a.442.442 0 0 1-.11-.6c.14-.19 4.8-6.1 4.8-6.1s-3.95 6.39-4.09 6.59Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.535,
    d: "M589.14 499.071c-.19.27-.55.33-.82.14a.582.582 0 0 1-.14-.82c.19-.27 6.56-8.34 6.56-8.34s-5.41 8.76-5.6 9.02Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.634,
    d: "M334.96 332.78a.64.64 0 0 1-1.05-.73c.2-.29 7.13-9.06 7.13-9.06s-5.87 9.5-6.08 9.79Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.953,
    d: "M233.54 435.781c-.58.82-1.71 1.02-2.53.45a1.825 1.825 0 0 1-.45-2.53c.58-.82 20.24-25.73 20.24-25.73s-16.68 26.99-17.26 27.81Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.645,
    d: "M498.29 440.701a1.924 1.924 0 0 1-3.15-2.21c.61-.87 21.43-27.23 21.43-27.23s-17.68 28.57-18.28 29.44Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.953,
    d: "M224.03 547.61c-.12.17-.36.22-.54.09a.384.384 0 0 1-.09-.54c.12-.17 4.29-5.45 4.29-5.45s-3.54 5.73-3.66 5.9Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.768,
    d: "M178.94 360.94c-.51.73-1.51.9-2.23.39-.73-.51-.9-1.51-.39-2.23.51-.73 17.88-22.72 17.88-22.72s-14.75 23.83-15.26 24.56Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    d: "M170 387.351c-.42.59-1.23.74-1.82.32-.59-.42-.74-1.23-.32-1.82.42-.59 14.6-18.55 14.6-18.55s-12.05 19.46-12.46 20.05Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.433,
    d: "M574.87 564.871a.575.575 0 0 1-.94-.66c.18-.26 6.39-8.11 6.39-8.11s-5.27 8.51-5.45 8.77Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "M261.13 500.581a.4.4 0 0 1-.55.1.4.4 0 0 1-.1-.55c.13-.18 4.42-5.62 4.42-5.62s-3.65 5.89-3.77 6.07Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M282.34 415.011a2.451 2.451 0 0 1-3.41.6c-1.11-.77-1.37-2.3-.6-3.41.78-1.11 27.26-34.64 27.26-34.64s-22.48 36.35-23.25 37.45Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "M424.91 562.461a.42.42 0 0 1-.59.1.42.42 0 0 1-.1-.59c.14-.19 4.75-6.04 4.75-6.04s-3.93 6.34-4.06 6.53Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M195.15 297.6c-.17.25-.52.31-.77.13a.547.547 0 0 1-.13-.77c.17-.25 6.14-7.8 6.14-7.8s-5.06 8.19-5.24 8.44Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    d: "M297.28 441.501a.42.42 0 0 1-.59.1.42.42 0 0 1-.1-.59c.14-.19 4.75-6.04 4.75-6.04s-3.92 6.34-4.06 6.53Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.756,
    d: "M595.02 401.01c-.1.15-.3.18-.45.08-.15-.1-.18-.3-.08-.45.1-.15 3.59-4.56 3.59-4.56s-2.96 4.78-3.06 4.93Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M313.73 480.431c-.32.46-.95.57-1.41.25-.46-.32-.57-.95-.25-1.41.32-.46 11.29-14.34 11.29-14.34s-9.31 15.04-9.63 15.5Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M422.29 311.241a.337.337 0 0 1-.55-.39c.11-.15 3.77-4.79 3.77-4.79s-3.12 5.03-3.22 5.18Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.737,
    d: "M462.92 465.331c-.17.24-.51.3-.75.13a.542.542 0 0 1-.13-.75c.17-.24 6-7.62 6-7.62s-4.94 7.99-5.12 8.24Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M581.83 296.871c-.27.39-.8.48-1.19.21a.851.851 0 0 1-.21-1.19c.27-.39 9.52-12.09 9.52-12.09s-7.85 12.68-8.12 13.07Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M190 488.361c-.58.82-1.71 1.02-2.53.44a1.814 1.814 0 0 1-.44-2.53c.58-.82 20.23-25.71 20.23-25.71s-16.68 26.98-17.26 27.8Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.602,
    d: "M128.1 467.14c-.1.14-.29.17-.42.07a.294.294 0 0 1-.07-.42c.1-.14 3.38-4.29 3.38-4.29s-2.8 4.5-2.89 4.64Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    d: "M470.81 506.85c-.54.77-1.61.96-2.38.42-.77-.54-.96-1.61-.42-2.38.54-.77 19.06-24.23 19.06-24.23s-15.72 25.41-16.26 26.19Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.424,
    d: "M136.43 566.331c-.1.15-.31.19-.46.08a.324.324 0 0 1-.08-.46c.11-.15 3.69-4.69 3.69-4.69s-3.04 4.92-3.15 5.07Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.532,
    d: "M582.38 454.61a.85.85 0 0 1-1.18.21.85.85 0 0 1-.21-1.18c.27-.38 9.43-11.98 9.43-11.98s-7.77 12.57-8.04 12.95Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.822,
    d: "M613.54 444.23c-.43.62-1.28.76-1.9.33-.62-.43-.76-1.28-.33-1.9.43-.62 15.17-19.28 15.17-19.28s-12.51 20.23-12.94 20.85Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.521,
    d: "M398.1 291.921c-.22.32-.66.39-.97.17a.693.693 0 0 1-.17-.97c.22-.32 7.79-9.9 7.79-9.9s-6.43 10.39-6.65 10.7Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.446,
    d: "M289.86 344.21a.73.73 0 0 1-1.03.18.73.73 0 0 1-.18-1.03c.23-.34 8.26-10.5 8.26-10.5s-6.82 11.02-7.05 11.35Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.955,
    d: "M267.47 431.29c-.14.2-.42.25-.63.11a.458.458 0 0 1-.11-.63c.14-.2 5.01-6.37 5.01-6.37s-4.12 6.68-4.27 6.89Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.678,
    d: "M468.02 431.901a1.623 1.623 0 0 1-2.66-1.86c.52-.74 18.12-23.03 18.12-23.03s-14.95 24.15-15.46 24.89Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "M288.3 508.19c-.55.78-1.62.97-2.4.42a1.72 1.72 0 0 1-.42-2.4c.55-.78 19.18-24.38 19.18-24.38s-15.81 25.59-16.36 26.36Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.846,
    d: "M436.99 481.85a.37.37 0 0 1-.52.09.37.37 0 0 1-.09-.52c.12-.17 4.15-5.27 4.15-5.27s-3.42 5.53-3.54 5.7Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M430.99 522.19c-.23.33-.69.41-1.03.18a.737.737 0 0 1-.18-1.03c.23-.34 8.21-10.43 8.21-10.43s-6.77 10.94-7 11.28Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.949,
    d: "M175.51 511.37a.7.7 0 0 1-.97.17.7.7 0 0 1-.17-.97c.22-.31 7.74-9.84 7.74-9.84s-6.38 10.33-6.6 10.64Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.696,
    d: "M126.18 335.13a.465.465 0 1 1-.76-.54c.15-.21 5.18-6.59 5.18-6.59s-4.27 6.92-4.42 7.13Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.897,
    d: "M205.71 520.651a.51.51 0 0 1-.71.12.51.51 0 0 1-.12-.71c.16-.23 5.64-7.17 5.64-7.17s-4.65 7.53-4.81 7.76Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    d: "M503.99 402.96a1.156 1.156 0 1 1-1.89-1.33c.37-.52 12.92-16.42 12.92-16.42s-10.66 17.22-11.03 17.75Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.799,
    d: "M481.86 370.981c-.31.44-.91.54-1.35.24a.975.975 0 0 1-.24-1.35c.31-.44 10.78-13.69 10.78-13.69s-8.88 14.36-9.19 14.8Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.579,
    d: "M209.74 449.45c-.33.47-.98.59-1.45.26-.47-.33-.59-.98-.26-1.45.33-.47 11.62-14.76 11.62-14.76s-9.58 15.48-9.91 15.95Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.555,
    d: "M268.83 319.171a1.8 1.8 0 0 1-2.52.44 1.8 1.8 0 0 1-.44-2.52c.57-.82 20.19-25.66 20.19-25.66s-16.65 26.92-17.23 27.74Z",
    fill: "#6BC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.901,
    d: "M214.68 382.88a1.87 1.87 0 0 1-2.59.46 1.87 1.87 0 0 1-.46-2.59c.59-.84 20.72-26.33 20.72-26.33s-17.08 27.62-17.67 28.46Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.77,
    d: "M236.76 335.191c-.39.55-1.14.68-1.69.3-.55-.39-.68-1.14-.3-1.69.39-.55 13.55-17.21 13.55-17.21s-11.18 18.05-11.56 18.6Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.511,
    d: "M564.32 343.91c-.12.17-.36.21-.53.09a.383.383 0 0 1-.09-.53c.12-.17 4.25-5.4 4.25-5.4s-3.51 5.67-3.63 5.84Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.841,
    d: "M508.59 328.3a.288.288 0 0 1-.47-.33c.09-.13 3.2-4.06 3.2-4.06s-2.64 4.26-2.73 4.39Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M184.79 420.89a.288.288 0 0 1-.47-.33c.09-.13 3.21-4.08 3.21-4.08s-2.65 4.28-2.74 4.41Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.617,
    d: "M612.96 570.24a2.216 2.216 0 0 1-3.1.54 2.216 2.216 0 0 1-.54-3.1c.7-1.01 24.78-31.49 24.78-31.49s-20.44 33.04-21.14 34.05Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.896,
    d: "M531.54 441.361c-.13.19-.4.24-.59.1a.419.419 0 0 1-.1-.59c.13-.19 4.74-6.02 4.74-6.02s-3.92 6.32-4.05 6.51Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.422,
    d: "M368.19 448.53a2.212 2.212 0 0 1-3.62-2.54c.7-1 24.67-31.34 24.67-31.34s-20.35 32.87-21.05 33.88Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.461,
    d: "M129.6 378.6a1.028 1.028 0 0 1-1.68-1.18c.33-.47 11.46-14.56 11.46-14.56s-9.46 15.28-9.78 15.74Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.743,
    d: "M245.16 477.07c-.61.87-1.81 1.08-2.67.47a1.914 1.914 0 0 1-.47-2.67c.61-.87 21.4-27.2 21.4-27.2s-17.65 28.53-18.26 29.4Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M327.93 461.99c-.58.82-1.71 1.02-2.53.44a1.814 1.814 0 0 1-.44-2.53c.58-.82 20.23-25.71 20.23-25.71s-16.69 26.98-17.26 27.8Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.858,
    d: "M329.99 283.26c-.1.14-.3.18-.44.08a.32.32 0 0 1-.08-.44c.1-.14 3.54-4.49 3.54-4.49s-2.92 4.7-3.02 4.85Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.818,
    d: "M315.05 403.67a1.989 1.989 0 1 1-3.26-2.28c.63-.9 22.16-28.16 22.16-28.16s-18.27 29.55-18.9 30.44Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.632,
    d: "M519.21 290.331c-.12.17-.36.22-.53.09a.374.374 0 0 1-.09-.53c.12-.17 4.27-5.42 4.27-5.42s-3.53 5.68-3.65 5.86Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M491.21 457.881c-.14.2-.42.25-.62.11a.448.448 0 0 1-.11-.62c.14-.2 4.93-6.27 4.93-6.27s-4.06 6.58-4.2 6.78Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.544,
    d: "M380.99 398.78c-.23.33-.68.41-1.01.18a.723.723 0 0 1-.18-1.01c.23-.33 8.12-10.32 8.12-10.32s-6.7 10.82-6.93 11.15Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.605,
    d: "M580.39 336.4a2.423 2.423 0 0 1-3.38.59 2.423 2.423 0 0 1-.59-3.38c.77-1.1 27.04-34.36 27.04-34.36s-22.3 36.05-23.07 37.15Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.575,
    d: "M156.39 406.95a.29.29 0 0 1-.41.07.29.29 0 0 1-.07-.41c.09-.13 3.3-4.19 3.3-4.19s-2.73 4.4-2.82 4.53Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.883,
    d: "M359.11 530.45c-.65.93-1.93 1.15-2.85.5a2.042 2.042 0 0 1-.5-2.85c.65-.93 22.84-29.03 22.84-29.03s-18.84 30.46-19.49 31.38Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.461,
    d: "M320.57 423.88a.61.61 0 1 1-1-.7c.19-.27 6.83-8.68 6.83-8.68s-5.63 9.1-5.83 9.38Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    d: "M395.47 337.08c-.31.44-.91.55-1.35.24a.966.966 0 0 1-.24-1.35c.31-.44 10.84-13.78 10.84-13.78s-8.94 14.45-9.25 14.89Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.488,
    d: "M146.25 520.15c-.15.21-.43.26-.64.11a.454.454 0 0 1-.11-.64c.15-.21 5.15-6.54 5.15-6.54s-4.25 6.86-4.4 7.07ZM314.39 360.301a.4.4 0 0 1-.55.1.398.398 0 0 1-.1-.55c.13-.18 4.43-5.63 4.43-5.63s-3.66 5.9-3.78 6.08Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.971,
    d: "M528.42 362.05c-.21.3-.63.38-.94.16a.672.672 0 0 1-.16-.94c.21-.3 7.5-9.53 7.5-9.53s-6.19 10.01-6.4 10.31Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.907,
    d: "M484.99 295.53c-.3.42-.88.52-1.3.23a.942.942 0 0 1-.23-1.3c.3-.42 10.4-13.21 10.4-13.21s-8.58 13.86-8.87 14.28Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.853,
    d: "M467.65 346.58c-.7.99-2.07 1.23-3.06.54-.99-.7-1.23-2.07-.54-3.06.7-.99 24.48-31.11 24.48-31.11s-20.18 32.63-20.88 33.63Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.848,
    d: "M546.29 481.971c-.58.83-1.72 1.03-2.54.45a1.819 1.819 0 0 1-.45-2.54c.58-.83 20.35-25.86 20.35-25.86s-16.78 27.12-17.36 27.95Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.707,
    d: "M127.77 545.05c-.14.2-.41.24-.6.11a.434.434 0 0 1-.11-.6c.14-.2 4.81-6.11 4.81-6.11s-3.97 6.41-4.1 6.6Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "M557.01 441.28a1.861 1.861 0 0 1-3.05-2.13c.59-.84 20.74-26.36 20.74-26.36s-17.1 27.65-17.69 28.49Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.704,
    d: "M128.58 403.191c-.12.17-.36.21-.53.09a.383.383 0 0 1-.09-.53c.12-.17 4.26-5.41 4.26-5.41s-3.52 5.68-3.64 5.85Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.884,
    d: "M346.48 562.601c-.32.46-.95.57-1.41.25-.46-.32-.57-.95-.25-1.41.32-.46 11.28-14.34 11.28-14.34s-9.29 15.04-9.62 15.5Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.406,
    d: "M290.24 285.861c-.09.13-.27.16-.39.07a.277.277 0 0 1-.07-.39c.09-.13 3.16-4.02 3.16-4.02s-2.61 4.21-2.7 4.34Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.805,
    d: "M546.96 400.03c-.11.15-.32.19-.48.08a.348.348 0 0 1-.08-.48c.11-.15 3.81-4.84 3.81-4.84s-3.14 5.09-3.25 5.24Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M320.9 546.18a.29.29 0 0 1-.41.07.29.29 0 0 1-.07-.41c.09-.13 3.29-4.18 3.29-4.18s-2.72 4.39-2.81 4.52Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M493.96 559.28c-.63.9-1.87 1.12-2.76.49-.9-.63-1.12-1.87-.49-2.76.63-.9 22.12-28.11 22.12-28.11s-18.24 29.48-18.87 30.38Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.496,
    d: "M459.6 308.27c-.17.24-.51.3-.75.13a.542.542 0 0 1-.13-.75c.17-.24 6.03-7.67 6.03-7.67s-4.98 8.05-5.15 8.29Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M512.04 523.24c-.62.89-1.84 1.1-2.73.48-.89-.62-1.1-1.84-.48-2.73.62-.89 21.83-27.74 21.83-27.74s-18 29.1-18.62 29.99Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.459,
    d: "M420.01 393.461a.337.337 0 0 1-.55-.39c.11-.15 3.78-4.8 3.78-4.8s-3.13 5.04-3.23 5.19Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.964,
    d: "M553.2 537.751a1.349 1.349 0 1 1-2.21-1.55c.43-.61 15.07-19.15 15.07-19.15s-12.43 20.09-12.86 20.7Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.713,
    d: "M433.4 435.97a.53.53 0 1 1-.87-.61c.17-.24 5.94-7.54 5.94-7.54s-4.9 7.91-5.07 8.15Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.638,
    d: "M348.27 382.6c-.33.47-.98.59-1.46.26-.47-.33-.59-.98-.26-1.46.33-.47 11.67-14.83 11.67-14.83s-9.62 15.55-9.95 16.03Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.745,
    d: "M477.31 566.12c-.09.12-.26.15-.38.07a.284.284 0 0 1-.07-.38c.09-.12 3.04-3.86 3.04-3.86s-2.51 4.05-2.59 4.17Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.435,
    d: "M147.23 490.11c-.66.95-1.97 1.18-2.92.51a2.088 2.088 0 0 1-.51-2.92c.66-.95 23.34-29.66 23.34-29.66s-19.24 31.13-19.91 32.07Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.976,
    d: "M212.08 406.8c-.32.46-.96.58-1.43.25-.46-.32-.58-.96-.25-1.43.32-.46 11.42-14.51 11.42-14.51s-9.41 15.22-9.74 15.69Z",
    fill: "#3298D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.773,
    d: "M431.34 378.731c-.6.86-1.78 1.07-2.64.46-.86-.6-1.07-1.78-.46-2.64.6-.86 21.15-26.87 21.15-26.87s-17.45 28.19-18.05 29.05Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.801,
    d: "M593.1 368.871c-.69.98-2.05 1.22-3.03.53a2.17 2.17 0 0 1-.53-3.03c.69-.98 24.27-30.85 24.27-30.85s-20.02 32.37-20.71 33.35Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.774,
    d: "M259.94 353.271a.288.288 0 0 1-.47-.33c.09-.13 3.22-4.09 3.22-4.09s-2.65 4.29-2.75 4.42Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.534,
    d: "M369.2 322.37a1.056 1.056 0 0 1-1.73-1.21c.33-.48 11.78-14.96 11.78-14.96s-9.72 15.7-10.05 16.17Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.628,
    d: "M220.82 503.61a1.974 1.974 0 1 1-3.23-2.27c.63-.89 21.99-27.94 21.99-27.94s-18.13 29.32-18.76 30.21Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.658,
    d: "M204.6 565.27a.353.353 0 0 1-.58-.4c.11-.16 3.93-5 3.93-5s-3.24 5.24-3.35 5.4Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M616.61 332.721a2.337 2.337 0 0 1-3.25.57 2.328 2.328 0 0 1-.57-3.25c.74-1.05 25.98-33.02 25.98-33.02s-21.42 34.64-22.16 35.7Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.454,
    d: "M165.68 561.08c-.5.71-1.48.89-2.2.39-.71-.5-.89-1.48-.39-2.2.5-.71 17.6-22.36 17.6-22.36s-14.51 23.45-15.01 24.17Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.553,
    d: "M622.57 288.45c-.13.19-.4.24-.59.1a.419.419 0 0 1-.1-.59c.13-.19 4.7-5.97 4.7-5.97s-3.87 6.27-4.01 6.46Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.768,
    d: "M330.62 504.89a.29.29 0 0 1-.41.07.29.29 0 0 1-.07-.41c.09-.13 3.32-4.22 3.32-4.22s-2.75 4.42-2.84 4.56Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.682,
    d: "M439.18 341.75a.818.818 0 1 1-1.34-.94c.26-.37 9.11-11.58 9.11-11.58s-7.51 12.15-7.77 12.52Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.844,
    d: "M554.71 284.811c-.09.13-.26.16-.39.07a.276.276 0 0 1-.07-.39c.09-.13 3.1-3.94 3.1-3.94s-2.55 4.14-2.64 4.26Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.506,
    d: "M320.99 305.87c-.1.15-.3.18-.45.08-.15-.1-.18-.3-.08-.45.1-.15 3.58-4.55 3.58-4.55s-2.95 4.77-3.05 4.92Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.771,
    d: "M355.87 489.331a2.437 2.437 0 0 1-3.39.6 2.437 2.437 0 0 1-.6-3.39c.77-1.1 27.11-34.45 27.11-34.45s-22.35 36.14-23.12 37.24Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    d: "M450.13 407.14c-.46.66-1.37.82-2.02.36-.65-.46-.82-1.37-.36-2.02.46-.66 16.19-20.57 16.19-20.57s-13.35 21.57-13.81 22.23Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M447.17 554.64c-.43.62-1.28.77-1.9.33-.62-.43-.77-1.28-.33-1.9.43-.62 15.21-19.33 15.21-19.33s-12.54 20.28-12.98 20.9Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.475,
    d: "M258.76 564.261c-.1.14-.29.17-.43.08-.14-.09-.17-.29-.08-.43.1-.14 3.46-4.39 3.46-4.39s-2.85 4.6-2.95 4.74Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.859,
    d: "M627.63 399.29a.69.69 0 0 1-1.13-.79c.22-.31 7.65-9.72 7.65-9.72s-6.3 10.2-6.52 10.51Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    d: "M252.11 542.431c-.48.68-1.41.84-2.09.37-.68-.48-.84-1.41-.37-2.09.48-.68 16.74-21.28 16.74-21.28s-13.8 22.33-14.28 23Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M632.17 495.3c-.17.25-.51.31-.76.13a.535.535 0 0 1-.13-.76c.17-.25 6.08-7.73 6.08-7.73s-5.01 8.12-5.19 8.36Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.661,
    d: "M257.07 392.19a1.17 1.17 0 0 1-1.92-1.34c.37-.53 13.08-16.62 13.08-16.62s-10.79 17.43-11.16 17.96Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.767,
    d: "M385.75 562.291a.402.402 0 0 1-.66-.46c.13-.18 4.51-5.74 4.51-5.74s-3.73 6.01-3.85 6.2Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    d: "M401.38 475.03a2.162 2.162 0 0 1-3.54-2.48c.68-.98 24.09-30.61 24.09-30.61s-19.86 32.11-20.55 33.09Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.803,
    d: "M361.16 352.6a.56.56 0 0 1-.77.14.558.558 0 0 1-.14-.77c.18-.25 6.17-7.84 6.17-7.84s-5.08 8.22-5.26 8.47Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.478,
    d: "M471.03 531.81a1.156 1.156 0 1 1-1.89-1.33c.37-.52 12.88-16.36 12.88-16.36s-10.62 17.17-10.99 17.69Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M445.11 285.16c-.11.16-.34.2-.5.09a.365.365 0 0 1-.09-.5c.11-.16 4.04-5.13 4.04-5.13s-3.33 5.38-3.45 5.54Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.568,
    d: "M396.85 436.36a2.4 2.4 0 0 1-3.33.59 2.4 2.4 0 0 1-.59-3.33c.75-1.08 26.67-33.89 26.67-33.89s-22 35.55-22.75 36.63Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M538.68 323.67c-.52.75-1.56.93-2.31.41s-.93-1.56-.41-2.31 18.45-23.44 18.45-23.44-15.21 24.59-15.73 25.34Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.519,
    d: "M206.79 337.561c-.21.3-.63.38-.93.16a.661.661 0 0 1-.16-.93c.21-.3 7.47-9.49 7.47-9.49s-6.17 9.96-6.38 10.26Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.828,
    d: "M163.36 464.331a2.248 2.248 0 0 1-3.14.55 2.248 2.248 0 0 1-.55-3.14c.71-1.02 25.13-31.93 25.13-31.93s-20.73 33.5-21.44 34.52Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M137.63 306.27c-.62.88-1.84 1.1-2.72.48-.88-.62-1.1-1.84-.48-2.72.62-.88 21.78-27.67 21.78-27.67s-17.96 29.03-18.58 29.91Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M146.65 355.721c-.42.6-1.24.74-1.83.32-.6-.42-.74-1.24-.32-1.83.42-.6 14.68-18.65 14.68-18.65s-12.11 19.56-12.53 20.16Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.864,
    d: "M233.86 297.861c-.3.43-.9.54-1.33.23a.95.95 0 0 1-.23-1.33c.3-.43 10.66-13.54 10.66-13.54s-8.8 14.21-9.1 14.64Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.954,
    d: "M288.79 533.91c-.31.44-.92.55-1.36.24a.978.978 0 0 1-.24-1.36c.31-.44 10.92-13.88 10.92-13.88s-9.01 14.56-9.32 15Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.503,
    d: "M628.11 357.57c-.2.28-.58.35-.86.15a.613.613 0 0 1-.15-.86c.2-.28 6.87-8.73 6.87-8.73s-5.67 9.16-5.86 9.44Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.895,
    d: "M600.34 488.56a2.24 2.24 0 0 1-3.11.55 2.24 2.24 0 0 1-.55-3.11c.71-1.01 24.85-31.58 24.85-31.58s-20.48 33.13-21.19 34.14Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.499,
    d: "M621.28 518.84a.288.288 0 0 1-.47-.33c.09-.13 3.23-4.1 3.23-4.1s-2.67 4.3-2.76 4.43Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.465,
    d: "M398.47 527.791c-.14.2-.41.25-.61.11a.436.436 0 0 1-.11-.61c.14-.2 4.91-6.23 4.91-6.23s-4.05 6.53-4.19 6.73Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M559.84 388.34c-.69.98-2.04 1.22-3.01.53a2.156 2.156 0 0 1-.53-3.01c.69-.98 24.12-30.65 24.12-30.65s-19.9 32.15-20.58 33.13Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M535.16 557.93c-.12.17-.36.21-.53.09a.383.383 0 0 1-.09-.53c.12-.17 4.23-5.38 4.23-5.38s-3.49 5.65-3.61 5.82Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.428,
    d: "M125.4 504.05c-.16.22-.47.28-.69.12a.497.497 0 0 1-.12-.69c.16-.22 5.54-7.04 5.54-7.04s-4.58 7.38-4.73 7.61Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.624,
    d: "M394.84 491.49c-.09.12-.26.15-.38.07a.284.284 0 0 1-.07-.38c.09-.12 3.04-3.86 3.04-3.86s-2.5 4.04-2.59 4.17Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.892,
    d: "M130.76 438.22c-.25.35-.74.44-1.09.19a.785.785 0 0 1-.19-1.09c.25-.35 8.71-11.07 8.71-11.07s-7.18 11.61-7.43 11.97Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "M359.15 292.58c-.18.26-.54.33-.81.14a.577.577 0 0 1-.14-.81c.18-.26 6.45-8.2 6.45-8.2s-5.32 8.61-5.5 8.87Z",
    fill: "#B5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.467,
    d: "M395.34 368.44a1.04 1.04 0 0 1-1.7-1.2c.33-.47 11.58-14.71 11.58-14.71s-9.55 15.44-9.88 15.91Z",
    fill: "#B5E3FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 21.861,
    width: 388,
    height: 257.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9.844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.61
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.14902 0 0 0 0 0.647059 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_231_2760"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.457
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.820833 0 0 0 0 0.9355 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_231_2760",
    result: "effect2_innerShadow_231_2760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 698,
    y: -6.139,
    width: 388,
    height: 257.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9.844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.61
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.14902 0 0 0 0 0.647059 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_231_2760"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.457
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.820833 0 0 0 0 0.9355 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_231_2760",
    result: "effect2_innerShadow_231_2760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 462,
    y: 21.861,
    width: 388,
    height: 257.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9.844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.61
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.14902 0 0 0 0 0.647059 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_231_2760"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.457
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.820833 0 0 0 0 0.9355 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_231_2760",
    result: "effect2_innerShadow_231_2760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 216,
    y: 16.861,
    width: 388,
    height: 257.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9.844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.61
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.14902 0 0 0 0 0.647059 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_231_2760"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.457
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.820833 0 0 0 0 0.9355 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_231_2760",
    result: "effect2_innerShadow_231_2760"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 914,
    y: -11.139,
    width: 388,
    height: 257.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9.844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.61
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.14902 0 0 0 0 0.647059 0 0 0 0 0.901961 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_231_2760"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.457
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.820833 0 0 0 0 0.9355 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_231_2760",
    result: "effect2_innerShadow_231_2760"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.d751e5c3e06c54f50fceae1e92411e66.svg";
export { ForwardRef as ReactComponent };